import {createTemplate} from "@helpers/create-template.js";
import {snakeToCamel} from "@helpers/string-helper";

const template: HTMLTemplateElement | null = createTemplate(`
    <template>
        <div class="js-flip-card flip-card h-full flex flex-col items-stretch">
            <div class="flip-card-inner relative w-full h-full flex items-center flex-1 md:mt-[75px] cursor-pointer">
                <div data-animate="fadein" class="flip-card-front max-w-[10em] mx-auto bg-inherit max-md:hyphens-manual w-full h-full flex-center p-4 pt-0 text-headline font-headings" data-attribute="question">Frage</div>
                <div class="flip-card-back bg-inherit w-full h-full text-base lg:text-5xl flex-center absolute p-4 pt-0">
                    <div class="text max-w-5xl leading-[1.15em]" data-attribute="answer">Antwort</div>
                </div>
            </div>
            <button class="oi-button z-10 self-center" data-attribute="buttonText">Label</button>
        </div>
    </template>
`);


export default class FlipCard extends HTMLElement {
    private question: string
    private answer: string
    private label: string
    private color: string = "red";

    private flipCard: HTMLElement
    private buttonText: string;
    private initialized: boolean;

    /**
     * Add all attributes ot you web component.
     * For attributeChangedCallback() callback to fire when an attribute changes, you have to observe the attributes.
     */
    static get observedAttributes() {
        return [
            'question',
            'answer',
            'label',
            'color',
            'buttonText',
        ]
    }

    constructor() {
        super();
        this.appendChild(template.content.cloneNode(true));
    }

    // The browser calls this method when the element is
    // added to the DOM.
    connectedCallback() {
        this.initializeComponent();
    }

    // then will attibuteChangedCallback will be calles
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== newValue) {
            for (const item of FlipCard.observedAttributes) {
                if (item === name) {
                    const propertyName = snakeToCamel(item)
                    this[propertyName] = newValue //Set text in property
                }
            }
        }
        this.updateTextsfromAttributes()
    }

    /**
     * Sets texts of tags with a data-attribute with webcomponents attribute value
     */
    updateTextsfromAttributes() {
        FlipCard.observedAttributes.forEach((item) => {
            const propertyName = snakeToCamel(item)
            const selector = '[data-attribute=' + item + ']'
            this.querySelectorAll(selector).forEach((item) => {
                item.innerHTML = this[propertyName] //Get text from property and write to HTML
            })
        })
    }

    initializeComponent() {
        this.answer = this['answer']
        this.question = this['question']
        this.label = this['label']
        this.color = this['color']
        this.buttonText = this.label;

        this.updateTextsfromAttributes();
        this.flipCard = this.querySelector('.js-flip-card');
        this.flipCard.querySelector('.flip-card-inner')?.classList.add("bg-" + this.color)

        this.flipCard.addEventListener('click', () => {
            if (this.flipCard.classList.contains("show-answer")) {
                this.flipCard.classList.remove('show-answer');
                this.buttonText = this.label;
            } else {
                this.flipCard.classList.add('show-answer');
                this.buttonText = "Frage anzeigen";
            }

            this.updateTextsfromAttributes();
        });

    }
    
}
